var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBtnFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_btn_filter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter",
    transform: "translate(-553.97 -504.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.528,0H11.609a1.564,1.564,0,0,1,1.528,1.59V3.338a3.026,3.026,0,0,1-.764,1.828L9.089,8.186a2.637,2.637,0,0,0-.764,1.828v3.417a1.791,1.791,0,0,1-.687,1.351L6.568,15.5A1.555,1.555,0,0,1,4.2,14.147V9.934A3.146,3.146,0,0,0,3.59,8.265L.687,5.086A2.685,2.685,0,0,1,0,3.5V1.669A1.585,1.585,0,0,1,1.528,0Z",
    transform: "translate(559.4 510.1)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H19.937V19.937H0Z",
    transform: "translate(556 508)",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBtnFilter);
export default __webpack_public_path__ + "static/media/ic_btn_filter.5dc31d1bcaa20034880e05c3a9aa351d.svg";
export { ForwardRef as ReactComponent };